import styled from "styled-components";

export const Body = styled.div`
  display: grid;
  grid-auto-flow: column;
  `;
export const Container = styled.div`
  padding: 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* The app shell is a fixed 100vh flex column with the header on top, so a hard
     95vh here made this box taller than the room left under the header: its last
     ~30px - exactly where the table's horizontal scrollbar sits - fell off the
     bottom of the screen with nothing left to scroll. Filling the leftover row
     instead keeps that bottom edge inside the viewport. */
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  /* Was 3rem to make up for the clipped box above; now it is just dead space the
     table could be using. */
  padding-bottom: 1rem;
  .percentTag {
    width: 50px;
    text-align: center;
  }
`;
export const Filter = styled.div`
display: flex;
gap: 1rem;
background-color: #ffffff;
  padding: 1rem;
`;
